export const ROUTES = {
    Home: '',
    Browse: 'browse',
    Detail: 'details/:id',
};
